// import React, { useEffect, useState } from "react"
// import { Card, Col, Row } from "reactstrap"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import UpdateTable from "../../../components/Common/UpdatedTable"
// import { fetchFinanceVoucherSummary } from "../../../services/finance/finance"
// import moment from "moment"
// import { useLocation, useNavigate } from "react-router-dom"
// import NumberFormat from "../../../utils/numberFormat"
// import { createSelector } from "reselect"
// import { useSelector, useDispatch } from "react-redux"
// // import GroupSummaryFilter from "./filter"
// import { toastError } from "../../../helpers/msg_helper"
// import arrow from "../../../assets/icons/arrow.svg"
// import resetIcon from "../../../assets/icons/reset.svg"
// import { useForm } from "react-hook-form"
// import { UFDate } from "../../../components/Common/Fields/Input"
// import { setFilter, removeFilter } from "../../../store/actions"

// const MonthlyAccGroupReport = ({ fromDashboard }) => {
//   const location = useLocation()
//   const dispatch = useDispatch()
//   const pathName =
//     location?.pathname == "/finance/cash-monthly-report"
//       ? "Payment"
//       : location?.pathname == "/finance/bank-monthly-report"
//       ? "Payment"
//       : location?.pathname == "/finance/payment-monthly-report"
//       ? "Payment"
//       : location?.pathname == "/finance/receipt-monthly-report"
//       ? "Receipt"
//       : location?.pathname == "/finance/journal-monthly-report"
//       ? "Journal"
//       : location?.pathname == "/finance/purchase-monthly-report"
//       ? "Purchase"
//       : location?.pathname == "/finance/sales-monthly-report"
//       ? "Sales"
//       : location?.pathname == "/finance/debit-note-monthly-report"
//       ? "Debit Note"
//       : location?.pathname == "/finance/credit-note-monthly-report"
//       ? "Credit Note"
//       : location?.pathname == "/finance/bank-payment-monthly-report"
//       ? "Bank Payment"
//       : location?.pathname == "/finance/contra-monthly-report"
//       ? "Contra"
//       : "Account Book"

//   const companyname = localStorage.getItem("companyname")
//   document.title = `${pathName || "Account Book"}${
//     companyname ? ` | ${companyname}` : "MEP -Hub"
//   }`

//   const selectLoginState = state => state.Login
//   const LoginProperties = createSelector(selectLoginState, login => ({
//     loggedUser: login.loggedUser,
//   }))

//   const { loggedUser } = useSelector(LoginProperties)
//   const desimalrange = localStorage.getItem("desimalrange")

//   const selectFilterState = state => state.filterReducer
//   const filterProperties = createSelector(selectFilterState, filter => ({
//     filters: filter.filters,
//     filterLoading: filter.loading,
//     filterError: filter.error
//   }))

//   const { filters, filterLoading, filterError } = useSelector(filterProperties)
//   console.log("filtersdata", filters, filterLoading, filterError)

//   const navigate = useNavigate()
//   const [search, setSearch] = useState("")
//   const [page, setPage] = useState(1)
//   const [fetchedData, setFetchedData] = useState()
//   const [groupedData, setGroupData] = useState()
//   const [refresh, setRefresh] = useState(0)
//   const [dateFrom, setDatefrom] = useState(
//     moment().startOf("year").format("YYYY-MM-DD")
//   )
//   const [dateTo, setDateto] = useState(
//     moment().endOf("year").format("YYYY-MM-DD")
//   )
//   const [acc, setAcc] = useState(
//     pathName == "Payment"
//       ? [3, 21]
//       : pathName == "Payment"
//       ? [3, 21]
//       : pathName == "Receipt"
//       ? [6]
//       : pathName == "Journal"
//       ? [8]
//       : pathName == "Purchase"
//       ? [15]
//       : pathName == "Sales"
//       ? [13]
//       : pathName == "Debit Note"
//       ? [4]
//       : pathName == "Credit Note"
//       ? [18]
//       : pathName == "Contra"
//       ? [1]
//       : 0
//   )
//   const { control, watch, reset, setValue } = useForm()
//   console.log(`acc`, acc)

//   const [viewData, setViewData] = useState()
//   const [modal, setModal] = useState(false)
//   const [dataPerPage, setDataPerPage] = useState(1000)

//   const [summary, setSummary] = useState({
//     totalDebit: 0,
//     totalCredit: 0,
//     closingBalance: 0,
//     closingType: "Dr",
//     totalCount: 0,
//   })

//   useEffect(() => {
//     reset({
//       start_date: dateFrom,
//       end_date: dateTo,
//     })
//   }, [])

//   const toggle = () => setModal(!modal)

//   const [voucherTypeId, setVoucherTypeId] = useState("")

//   useEffect(() => {
//     setAcc(
//       pathName == "Payment"
//         ? [3, 21]
//         : pathName == "Payment"
//         ? [3, 21]
//         : pathName == "Receipt"
//         ? [6]
//         : pathName == "Journal"
//         ? [8]
//         : pathName == "Purchase"
//         ? [15]
//         : pathName == "Sales"
//         ? [13]
//         : pathName == "Debit Note"
//         ? [4]
//         : pathName == "Credit Note"
//         ? [18]
//         : pathName == "Contra"
//         ? [1]
//         : 0
//     )
//     setDatefrom(
//       location?.state?.startDate ??
//         moment().startOf("year").format("YYYY-MM-DD")
//     )
//     setDateto(
//       location?.state?.endDate ?? moment().endOf("year").format("YYYY-MM-DD")
//     )
//     setPage(1)
//   }, [pathName])

//   const calculateSummary = (monthly_summary = []) => {
//     let totalDebit = 0
//     let totalCredit = 0
//     let totalCount = 0

//     monthly_summary.forEach(item => {
//       totalDebit += item.net_debit || 0
//       totalCredit += item.net_credit || 0
//       totalCount += item.entry_count || 0
//     })

//     const closingBalance = Math.abs(totalDebit - totalCredit)
//     const closingType = totalDebit > totalCredit ? "debit" : "credit"

//     return { totalDebit, totalCredit, closingBalance, closingType, totalCount }
//   }

//   useEffect(() => {
//     const fetchData = async () => {
//       if (filters?.dateFrom || filters?.dateTo) {
//       try {
//         const responce = await fetchFinanceVoucherSummary({
//           params: `${
//             search ? `searchText=${search}` : "searchText"
//           }${`&monthly_summary=true`}${page ? `&page=${page}` : ""}${
//             acc && acc.length
//               ? acc.map(id => `&voucher_id[]=${id}`).join("")
//               : ""
//           }${
//             filters?.dateFrom 
//               ? `&start_date=${filters?.dateFrom }`
//               : `&start_date=${moment().startOf("year").format("YYYY-MM-DD")}`
//           }${
//             filters?.dateTo
//               ? `&end_date=${filters?.dateTo}`
//               : `&end_date=${moment().endOf("year").format("YYYY-MM-DD")}`
//           }`,
//         })

//         const result = calculateSummary(
//           responce?.data[0]?.monthly_summary || []
//         )
//         setSummary(result)

//         setFetchedData(responce)
//       } catch (err) {
//         toastError(err?.message)
//         setFetchedData(null)
//         // setGroupData([])
//         // ${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}
//       }
//     }
//     }
//     if (acc != undefined && acc !== "" && acc !== 0) {
//       fetchData()
//     }
//     reset({
//       start_date: filters?.dateFrom,
//       end_date: filters?.dateTo,
//     })
//   }, [filters?.dateFrom, filters?.dateTo])

//   // acc ? `&voucher_id=${acc}` : ""
//   useEffect(() => {
//     if (filters?.dateFrom || filters?.dateTo) return;
//     const fetchData = async () => {
//       try {
//         const responce = await fetchFinanceVoucherSummary({
//           params: `${
//             search ? `searchText=${search}` : "searchText"
//           }${`&monthly_summary=true`}${page ? `&page=${page}` : ""}${
//             acc && acc.length
//               ? acc.map(id => `&voucher_id[]=${id}`).join("")
//               : ""
//           }${
//             dateFrom
//               ? `&start_date=${dateFrom}`
//               : `&start_date=${moment().startOf("year").format("YYYY-MM-DD")}`
//           }${
//             dateTo
//               ? `&end_date=${dateTo}`
//               : `&end_date=${moment().endOf("year").format("YYYY-MM-DD")}`
//           }`,
//         })

//         const result = calculateSummary(
//           responce?.data[0]?.monthly_summary || []
//         )
//         setSummary(result)

//         setFetchedData(responce)
//       } catch (err) {
//         toastError(err?.message)
//         setFetchedData(null)
//         // setGroupData([])
//         // ${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}
//       }
//     }
//     if (acc != undefined && acc !== "" && acc !== 0) {
//       fetchData()
//     }
//   }, [acc, dateFrom, dateTo, refresh])
//   const handleVoucherTypeChange = id => {
//     setVoucherTypeId(id)
//     setPage(1)
//   }

//   // ${dateFrom ? `&start_date=${dateFrom}` : ""}${
//   //   dateTo ? `&end_date=${dateTo}` : ""
//   // }

//   const handleView = item => {
//     setViewData(item)
//     toggle()
//   }

//   const handleSizePerPageChange = size => {
//     setDataPerPage(size)
//   }

//   const handleScroll = e => {
//     console.log("scroll event fired", e.target.scrollTop)
//     const { scrollTop, scrollHeight, clientHeight } = e.target

//     console.log(
//       `scrollTop, scrollHeight, clientHeight`,
//       e,
//       scrollTop,
//       scrollHeight,
//       clientHeight
//     )

//     if (scrollHeight - scrollTop <= clientHeight + 50) {
//       // near bottom
//       if (page < fetchedData?.last_page) {
//         setPage(prev => prev + 1)
//       }
//     }
//   }

//   const columns = [
//     {
//       label: "Particulars",
//       renderCell: item => (
//         <div
//           onClick={() => {
//             navigate(
//               `${
//                 pathName == "Payment"
//                   ? "/finance/cash-payment-register"
//                   : pathName == "Payment"
//                   ? "/finance/bank-payment-register"
//                   : pathName == "Receipt"
//                   ? "/finance/receipt-register"
//                   : pathName == "Journal"
//                   ? "/finance/journal-register"
//                   : pathName == "Purchase"
//                   ? "/finance/purchase-register"
//                   : pathName == "Sales"
//                   ? "/finance/sales-register"
//                   : pathName == "Debit Note"
//                   ? "/finance/debit-note-register"
//                   : pathName == "Credit Note"
//                   ? "/finance/credit-note-register"
//                   : pathName == "Contra"
//                   ? "/finance/contra-register"
//                   : "/finance/account-book"
//               }`,
//               {
//                 state: {
//                   item,
//                   startDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
//                     .startOf("month")
//                     .format("YYYY-MM-DD"),
//                   endDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
//                     .endOf("month")
//                     .format("YYYY-MM-DD"),
//                   //   ledger_id: id,
//                   //   ledger_name: location?.state?.item?.ledger_name,
//                 },
//               }
//             )
//             dispatch(setFilter({dateFrom: dateFrom, dateTo: dateTo}))
//           }
//           }
//           className="pointer fw-bold"
//         >
//           {item?.month}
//         </div>
//       ),
//     },
//     ...(pathName == "Sales" || pathName == "Purchase"
//       ? [
//           {
//             label: <div className="text-end">Debit (AED)</div>,
//             renderCell: item => {
//               const debitPaths = [
//                 "Purchase",
//                 "Journal",
//                 "Payment",
//                 "Debit Note",
//               ]

//               return (
//                 <div className="text-end">
//                   {debitPaths.includes(pathName)
//                     ? NumberFormat(
//                         item?.net_debit ?? 0,
//                         desimalrange,
//                         desimalrange
//                       )
//                     : 0}
//                 </div>
//               )
//             },
//           },
//           {
//             label: <div className="text-end pe-5">Credit (AED)</div>,
//             renderCell: item => {
//               const creditPaths = ["Sales", "Receipt", "Credit Note"]

//               return (
//                 <div className="text-end pe-5">
//                   {creditPaths.includes(pathName)
//                     ? NumberFormat(
//                         item?.net_credit ?? 0,
//                         desimalrange,
//                         desimalrange
//                       )
//                     : 0}
//                 </div>
//               )
//             },
//           },
//         ]
//       : [
//           {
//             label: <div className="text-end pe-5">Count</div>,
//             renderCell: item => (
//               <div className="text-end pe-5">{item?.entry_count ?? 0}</div>
//             ),
//           },
//         ]),

//     // {
//     //   label: <div className="text-end pe-5">Debit (AED)</div>,
//     //   renderCell: item => (
//     //     <div className="text-end pe-5">
//     //       {NumberFormat(item?.net_debit, desimalrange, desimalrange)}
//     //     </div>
//     //   ),
//     // },
//     // {
//     //   label: <div className="text-end pe-5">Credit (AED)</div>,
//     //   renderCell: item => (
//     //     <div className="text-end pe-5">
//     //       {NumberFormat(item?.net_credit, desimalrange, desimalrange)}
//     //     </div>
//     //   ),
//     // },
//     // {
//     //   label: <div className="text-end pe-3">Closing Balance (AED)</div>,
//     //   renderCell: item => (
//     //     <div className="text-end pe-3">
//     //       {NumberFormat(item?.net_balance, desimalrange, desimalrange)}{" "}
//     //       {item?.closing_type == "credit" ? "Cr" : "Dr"}
//     //     </div>
//     //   ),
//     // },
//   ]
//   const viewColumn = [
//     {
//       label: "Group Name",
//       renderCell: item => (
//         <div
//           onClick={() => {
//             navigate(`/finance-ledger-acc`, {
//               state: item,
//             })
//             dispatch(setFilter({dateFrom: dateFrom, dateTo: dateTo}))
//           }
//           }
//           className="pointer fw-bold fs-13 ps-2"
//         >
//           {item?.ledger_name}
//           <span className="ps-1">
//             <img src={arrow} alt="" width="7" />
//           </span>
//         </div>
//       ),
//     },
//     {
//       label: "Amount",
//       label: "Amount",
//       renderCell: item => (
//         <div className="text-end pe-5">
//           {NumberFormat(Number(item?.currentDebit), desimalrange, desimalrange)}
//           AED
//         </div>
//       ),
//     },
//     {
//       label: "Amount",
//       renderCell: item => (
//         <div className="text-end pe-5">
//           {NumberFormat(
//             Number(item?.currentCredit),
//             desimalrange,
//             desimalrange
//           )}{" "}
//           AED
//         </div>
//       ),
//     },
//   ]

//   const handlePaginate = page => {
//     setPage(page)
//   }

//   const handleSearchChange = data => {
//     setSearch(data)
//     setPage(1)
//   }

//   const handleDateChange = (fromdate, todate) => {
//     setDatefrom(fromdate)
//     setDateto(todate)
//     setPage(1)
//   }

//   const handleAccChange = data => {
//     setAcc([data])
//     setPage(1)
//   }

//   const handleReset = () => {
//         reset()
//         setDatefrom(moment().startOf("year").format("YYYY-MM-DD"))
//         setDateto(moment().endOf("year").format("YYYY-MM-DD"))
//         setRefresh(refresh + 1)
//         dispatch(removeFilter())
//       }

//   return (
//     <React.Fragment>
//       <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
//         <div className="container-fluid">
//           <div className="d-flex justify-content-between">
//             {!fromDashboard ? (
//               <>
//                 <Breadcrumbs
//                   title="Finance"
//                   breadcrumbObject={[
//                     { title: "Finance", link: "/finance" },
//                     { title: "Account Book", link: "/finance" },
//                     { title: pathName, link: "" },
//                   ]}
//                 />
//               </>
//             ) : (
//               <></>
//             )}
//             <div className="pe-2 d-flex align-items-center">
//                           <div
//                             className="export-div pointer reset-img me-2 py-2"
//                             onClick={() => handleReset()}
//                           >
//                             <img src={resetIcon} height={15} width={15} className="" />{" "}
//                           </div>
//                           <div className="me-2">
//                             <UFDate
//                               control={control}
//                               name="start_date"
//                               placeholder="Start Date"
//                               mode="single"
//                               onDateChange={([date]) =>
//                                 setDatefrom(date ? moment(date).format("YYYY-MM-DD") : "")
//                               }
//                               maxDate={dateTo || undefined}
//                               readOnly={false}
//                               widthClass="w-100"
//                             />
//                           </div>
//                           {/* End Date */}
//                           <div className="me-2">
//                             <UFDate
//                               control={control}
//                               name="end_date"
//                               placeholder="End Date"
//                               mode="single"
//                               onDateChange={([date]) =>
//                                 setDateto(date ? moment(date).format("YYYY-MM-DD") : "")
//                               }
//                               minDate={dateFrom || undefined}
//                               readOnly={false}
//                               widthClass="w-100"
//                             />
//                           </div>
//                         </div>
//             {/* <>
//                         <div className="me-2">
//                           <span id={`PopoverLegacy-1`} className="px-2 mb-3 btn btn-primary">
//                             Download
//                           </span>
                          
//                         </div>
//                         <UncontrolledPopover
//                             placement="bottom"
//                             target={`PopoverLegacy-1`}
//                             trigger="legacy"
//                           >
//                             <PopoverBody>
//                               <div
//                                 className="table-popup-content"
//                                 onClick={() =>
//                                   downloadDayBook("pdf", "coa.pdf")
//                                 }
//                               >
//                                 PDF
//                               </div>
//                               <div
//                                 className="table-popup-content"
//                                 onClick={() =>
//                                   downloadDayBook("excel", "coa.xlsx")
//                                 }
//                               >
//                                 Excel
//                               </div>
//                             </PopoverBody>
//                           </UncontrolledPopover>
//                         </> */}
//           </div>
//           <Card
//             className={`me-2 px-2 pb-2 ${
//               fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
//             }`}
//           >
//             {/* {!fromDashboard ? (
//               <>
//                 <GroupSummaryFilter
//                   handleSearchChange={handleSearchChange}
//                   handleDateChange={handleDateChange}
//                   handleAccChange={handleAccChange}
//                   isImport={false}
//                   isGroup={pathName == "Group Summary" ? true : false}
//                   //   handleVoucherTypeChange={handleVoucherTypeChange}
//                 />
//                 <hr className="table-divide" />
//               </>
//             ) : (
//               <div></div>
//             )} */}
//             {fetchedData?.data?.length ? (
//               <Row className="mt-2 ever-rise-table accTable">
//                 <Col
//                   xs={12}
//                   // className="vh-60"
//                 >
//                   <div
//                     className="scrollable-table-container"
//                     style={{ height: "68vh", overflowY: "auto" }}
//                     onScroll={handleScroll}
//                   >
//                     {fetchedData?.data?.length && (
//                       <UpdateTable
//                         className="mt-5"
//                         nodes={fetchedData?.data[0]?.monthly_summary}
//                         // paginate={fetchedData}
//                         CurrentPage={page}
//                         columns={columns}
//                         subColumn={viewColumn}
//                         subName={"ledgers"}
//                         subHeader={false}
//                         expand={true}
//                         handlePagination={handlePaginate}
//                         // handleSizePerPage={handleSizePerPageChange}
//                         // hidePaginate={true}
//                         tableWidth={
//                           pathName === "Sales" || pathName === "Purchase"
//                             ? "40% 30% 30%"
//                             : "40% 60%"
//                         }
//                         mobileWidth={
//                           pathName === "Sales" || pathName === "Purchase"
//                             ? "80% 50% 50%"
//                             : "80% 60%"
//                         }
//                       />
//                     )}
//                   </div>
//                 </Col>
//                 {fetchedData?.data[0]?.monthly_summary?.length ? (
//                   <Row className="mt-2 fw-bold">
//                     <Col lg={6}>Grand Total</Col>
//                     {["Sales", "Purchase"].includes(pathName) ? (
//                       <>
//                         <Col lg={3} className="text-end pe-5">
//                           {NumberFormat(
//                             Math.abs(
//                               Number(
//                                 [
//                                   "Sales",
//                                   "Payment",
//                                   // "Cash Receipt",
//                                   "Credit Note",
//                                 ].includes(pathName)
//                                   ? 0
//                                   : summary?.totalDebit || 0
//                               )
//                             ),
//                             desimalrange,
//                             desimalrange
//                           )}
//                         </Col>
//                         <Col lg={3} className="text-end pe-5">
//                           {NumberFormat(
//                             Math.abs(
//                               Number(
//                                 [
//                                   "Sales",
//                                   // "Bank Receipt",
//                                   "Receipt",
//                                   "Credit Note",
//                                 ].includes(pathName)
//                                   ? summary?.totalCredit || 0
//                                   : 0
//                               )
//                             ),
//                             desimalrange,
//                             desimalrange
//                           )}
//                         </Col>{" "}
//                       </>
//                     ) : (
//                       <Col lg={6} className="text-end pe-5">
//                         {NumberFormat(
//                           Math.abs(Number(summary?.totalCount || 0)),
//                           desimalrange,
//                           desimalrange
//                         )}
//                       </Col>
//                     )}
//                   </Row>
//                 ) : (
//                   <></>
//                 )}
//               </Row>
//             ) : (
//               <div className="text-center p-4">No data Found</div>
//             )}
//           </Card>
//         </div>
//       </div>
//     </React.Fragment>
//   )
// }

// export default MonthlyAccGroupReport
import React, { useEffect, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import { fetchFinanceVoucherSummary } from "../../../services/finance/finance"
import moment from "moment"
import { useLocation, useNavigate } from "react-router-dom"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import { toastError } from "../../../helpers/msg_helper"
import arrow from "../../../assets/icons/arrow.svg"
import resetIcon from "../../../assets/icons/reset.svg"
import { useForm } from "react-hook-form"
import { UFDate } from "../../../components/Common/Fields/Input"
import { setFilter, removeFilter } from "../../../store/actions"

const MonthlyAccGroupReport = ({ fromDashboard }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const pathName =
    location?.pathname == "/finance/cash-monthly-report"
      ? "Payment"
      : location?.pathname == "/finance/bank-monthly-report"
      ? "Payment"
      : location?.pathname == "/finance/payment-monthly-report"
      ? "Payment"
      : location?.pathname == "/finance/receipt-monthly-report"
      ? "Receipt"
      : location?.pathname == "/finance/journal-monthly-report"
      ? "Journal"
      : location?.pathname == "/finance/purchase-monthly-report"
      ? "Purchase"
      : location?.pathname == "/finance/sales-monthly-report"
      ? "Sales"
      : location?.pathname == "/finance/debit-note-monthly-report"
      ? "Debit Note"
      : location?.pathname == "/finance/credit-note-monthly-report"
      ? "Credit Note"
      : location?.pathname == "/finance/bank-payment-monthly-report"
      ? "Bank Payment"
      : location?.pathname == "/finance/contra-monthly-report"
      ? "Contra"
      : "Account Book"

  const companyname = localStorage.getItem("companyname")
  document.title = `${pathName || "Account Book"}${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)

  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [groupedData, setGroupData] = useState()
  const [refresh, setRefresh] = useState(0)
  
  // FIX 1: Set default dates as constants
  const defaultStartDate = moment().startOf("year").format("YYYY-MM-DD")
  const defaultEndDate = moment().endOf("year").format("YYYY-MM-DD")
  
  const [dateFrom, setDatefrom] = useState(defaultStartDate)
  const [dateTo, setDateto] = useState(defaultEndDate)
  
  const [acc, setAcc] = useState(
    pathName == "Payment"
      ? [3, 21]
      : pathName == "Payment"
      ? [3, 21]
      : pathName == "Receipt"
      ? [6]
      : pathName == "Journal"
      ? [8]
      : pathName == "Purchase"
      ? [15]
      : pathName == "Sales"
      ? [13]
      : pathName == "Debit Note"
      ? [4]
      : pathName == "Credit Note"
      ? [18]
      : pathName == "Contra"
      ? [1]
      : 0
  )
  
  // FIX 2: Initialize form with default values
  const { control, watch, reset, setValue } = useForm({
    defaultValues: {
      start_date: defaultStartDate,
      end_date: defaultEndDate
    }
  })

  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(1000)

  const [summary, setSummary] = useState({
    totalDebit: 0,
    totalCredit: 0,
    closingBalance: 0,
    closingType: "Dr",
    totalCount: 0,
  })

  // FIX 3: Remove the problematic useEffect and handle filter synchronization properly
  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo) {
      setDatefrom(filters.dateFrom || defaultStartDate)
      setDateto(filters.dateTo || defaultEndDate)
      setValue("start_date", filters.dateFrom || defaultStartDate)
      setValue("end_date", filters.dateTo || defaultEndDate)
    }
  }, [filters])

  const toggle = () => setModal(!modal)

  const [voucherTypeId, setVoucherTypeId] = useState("")

  useEffect(() => {
    setAcc(
      pathName == "Payment"
        ? [3, 21]
        : pathName == "Payment"
        ? [3, 21]
        : pathName == "Receipt"
        ? [6]
        : pathName == "Journal"
        ? [8]
        : pathName == "Purchase"
        ? [15]
        : pathName == "Sales"
        ? [13]
        : pathName == "Debit Note"
        ? [4]
        : pathName == "Credit Note"
        ? [18]
        : pathName == "Contra"
        ? [1]
        : 0
    )
    setDatefrom(
      location?.state?.startDate ?? defaultStartDate
    )
    setDateto(
      location?.state?.endDate ?? defaultEndDate
    )
    setPage(1)
  }, [pathName])

  const calculateSummary = (monthly_summary = []) => {
    let totalDebit = 0
    let totalCredit = 0
    let totalCount = 0

    monthly_summary.forEach(item => {
      totalDebit += item.net_debit || 0
      totalCredit += item.net_credit || 0
      totalCount += item.entry_count || 0
    })

    const closingBalance = Math.abs(totalDebit - totalCredit)
    const closingType = totalDebit > totalCredit ? "debit" : "credit"

    return { totalDebit, totalCredit, closingBalance, closingType, totalCount }
  }

  useEffect(() => {
    const fetchData = async () => {
      // FIX 4: Use current state values instead of relying on filters only
      const currentDateFrom = filters?.dateFrom || dateFrom
      const currentDateTo = filters?.dateTo || dateTo
      
      try {
        const responce = await fetchFinanceVoucherSummary({
          params: `${
            search ? `searchText=${search}` : "searchText"
          }${`&monthly_summary=true`}${page ? `&page=${page}` : ""}${
            acc && acc.length
              ? acc.map(id => `&voucher_id[]=${id}`).join("")
              : ""
          }${
            currentDateFrom
              ? `&start_date=${currentDateFrom}`
              : `&start_date=${defaultStartDate}`
          }${
            currentDateTo
              ? `&end_date=${currentDateTo}`
              : `&end_date=${defaultEndDate}`
          }`,
        })

        const result = calculateSummary(
          responce?.data[0]?.monthly_summary || []
        )
        setSummary(result)

        setFetchedData(responce)
      } catch (err) {
        toastError(err?.message)
        setFetchedData(null)
      }
    }
    
    if (acc != undefined && acc !== "" && acc !== 0) {
      fetchData()
    }
  }, [filters?.dateFrom, filters?.dateTo, dateFrom, dateTo, acc, refresh, page, search])

  const handleVoucherTypeChange = id => {
    setVoucherTypeId(id)
    setPage(1)
  }

  const handleView = item => {
    setViewData(item)
    toggle()
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleScroll = e => {
    const { scrollTop, scrollHeight, clientHeight } = e.target

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      if (page < fetchedData?.last_page) {
        setPage(prev => prev + 1)
      }
    }
  }

  const columns = [
    {
      label: "Particulars",
      renderCell: item => (
        <div
          onClick={() => {
            navigate(
              `${
                pathName == "Payment"
                  ? "/finance/cash-payment-register"
                  : pathName == "Payment"
                  ? "/finance/bank-payment-register"
                  : pathName == "Receipt"
                  ? "/finance/receipt-register"
                  : pathName == "Journal"
                  ? "/finance/journal-register"
                  : pathName == "Purchase"
                  ? "/finance/purchase-register"
                  : pathName == "Sales"
                  ? "/finance/sales-register"
                  : pathName == "Debit Note"
                  ? "/finance/debit-note-register"
                  : pathName == "Credit Note"
                  ? "/finance/credit-note-register"
                  : pathName == "Contra"
                  ? "/finance/contra-register"
                  : "/finance/account-book"
              }`,
              {
                state: {
                  item,
                  startDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
                    .startOf("month")
                    .format("YYYY-MM-DD"),
                  endDate: moment(`${item?.year}-${item?.month}`, "YYYY-MMMM")
                    .endOf("month")
                    .format("YYYY-MM-DD"),
                },
              }
            )
            dispatch(setFilter({dateFrom: dateFrom, dateTo: dateTo}))
          }}
          className="pointer fw-bold"
        >
          {item?.month}
        </div>
      ),
    },
    ...(pathName == "Sales" || pathName == "Purchase"
      ? [
          {
            label: <div className="text-end">Debit (AED)</div>,
            renderCell: item => {
              const debitPaths = [
                "Purchase",
                "Journal",
                "Payment",
                "Debit Note",
              ]

              return (
                <div className="text-end">
                  {debitPaths.includes(pathName)
                    ? NumberFormat(
                        item?.net_debit ?? 0,
                        desimalrange,
                        desimalrange
                      )
                    : 0}
                </div>
              )
            },
          },
          {
            label: <div className="text-end pe-5">Credit (AED)</div>,
            renderCell: item => {
              const creditPaths = ["Sales", "Receipt", "Credit Note"]

              return (
                <div className="text-end pe-5">
                  {creditPaths.includes(pathName)
                    ? NumberFormat(
                        item?.net_credit ?? 0,
                        desimalrange,
                        desimalrange
                      )
                    : 0}
                </div>
              )
            },
          },
        ]
      : [
          {
            label: <div className="text-end pe-5">Count</div>,
            renderCell: item => (
              <div className="text-end pe-5">{item?.entry_count ?? 0}</div>
            ),
          },
        ]),
  ]

  const viewColumn = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() => {
            navigate(`/finance-ledger-acc`, {
              state: item,
            })
            dispatch(setFilter({dateFrom: dateFrom, dateTo: dateTo}))
          }}
          className="pointer fw-bold fs-13 ps-2"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.currentDebit), desimalrange, desimalrange)}
          AED
        </div>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.currentCredit),
            desimalrange,
            desimalrange
          )}{" "}
          AED
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleAccChange = data => {
    setAcc([data])
    setPage(1)
  }

  // FIX 5: Proper reset function
  const handleReset = () => {
    // Reset to default dates
    setDatefrom(defaultStartDate)
    setDateto(defaultEndDate)
    
    // Reset form values
    reset({
      start_date: defaultStartDate,
      end_date: defaultEndDate
    })
    
    // Clear filters
    dispatch(removeFilter())
    
    // Refresh data
    setRefresh(prev => prev + 1)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: "Account Book", link: "/finance" },
                    { title: pathName, link: "" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <div className="pe-2 d-flex align-items-center">
              <div
                className="export-div pointer reset-img me-2 py-2"
                onClick={handleReset}
              >
                <img src={resetIcon} height={15} width={15} className="" />{" "}
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="start_date"
                  placeholder="Start Date"
                  mode="single"
                  onDateChange={([date]) => {
                    const newDate = date ? moment(date).format("YYYY-MM-DD") : defaultStartDate
                    setDatefrom(newDate)
                    setValue("start_date", newDate)
                  }}
                  maxDate={dateTo || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="end_date"
                  placeholder="End Date"
                  mode="single"
                  onDateChange={([date]) => {
                    const newDate = date ? moment(date).format("YYYY-MM-DD") : defaultEndDate
                    setDateto(newDate)
                    setValue("end_date", newDate)
                  }}
                  minDate={dateFrom || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
            </div>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {fetchedData?.data?.length ? (
              <Row className="mt-2 ever-rise-table accTable">
                <Col xs={12}>
                  <div
                    className="scrollable-table-container"
                    style={{ height: "68vh", overflowY: "auto" }}
                    onScroll={handleScroll}
                  >
                    {fetchedData?.data?.length && (
                      <UpdateTable
                        className="mt-5"
                        nodes={fetchedData?.data[0]?.monthly_summary}
                        CurrentPage={page}
                        columns={columns}
                        subColumn={viewColumn}
                        subName={"ledgers"}
                        subHeader={false}
                        expand={true}
                        handlePagination={handlePaginate}
                        tableWidth={
                          pathName === "Sales" || pathName === "Purchase"
                            ? "40% 30% 30%"
                            : "40% 60%"
                        }
                        mobileWidth={
                          pathName === "Sales" || pathName === "Purchase"
                            ? "80% 50% 50%"
                            : "80% 60%"
                        }
                      />
                    )}
                  </div>
                </Col>
                {fetchedData?.data[0]?.monthly_summary?.length ? (
                  <Row className="mt-2 fw-bold">
                    <Col lg={6}>Grand Total</Col>
                    {["Sales", "Purchase"].includes(pathName) ? (
                      <>
                        <Col lg={3} className="text-end pe-5">
                          {NumberFormat(
                            Math.abs(
                              Number(
                                [
                                  "Sales",
                                  "Payment",
                                  "Credit Note",
                                ].includes(pathName)
                                  ? 0
                                  : summary?.totalDebit || 0
                              )
                            ),
                            desimalrange,
                            desimalrange
                          )}
                        </Col>
                        <Col lg={3} className="text-end pe-5">
                          {NumberFormat(
                            Math.abs(
                              Number(
                                [
                                  "Sales",
                                  "Receipt",
                                  "Credit Note",
                                ].includes(pathName)
                                  ? summary?.totalCredit || 0
                                  : 0
                              )
                            ),
                            desimalrange,
                            desimalrange
                          )}
                        </Col>{" "}
                      </>
                    ) : (
                      <Col lg={6} className="text-end pe-5">
                        {NumberFormat(
                          Math.abs(Number(summary?.totalCount || 0)),
                          desimalrange,
                          desimalrange
                        )}
                      </Col>
                    )}
                  </Row>
                ) : (
                  <></>
                )}
              </Row>
            ) : (
              <div className="text-center p-4">No data Found</div>
            )}
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MonthlyAccGroupReport